import React, { useMemo, useState } from 'react'
import { Card, CardBody } from 'reactstrap'

import { useCartRedux, useConfirmDialog } from '@hooks'
import { GST_STALL_LIST } from '@common'
import { getDishImageUrl } from '@utils'

const CartItem = ({ product, index }) => {
    const [imageError, setImageError] = useState(false)
    const { confirm } = useConfirmDialog()
    const { plusQuantity, minusQuantity, removeItem, removeVariant } = useCartRedux()

    const selectionsMap = useMemo(() => {
        return product.selections.reduce(
            (acc, selection) => {
                const selectedOptions = selection.options

                return {
                    price:
                        acc.price +
                        selectedOptions.reduce((optionTotal, option) => optionTotal + option.sellPrice * option.quantity, 0),
                    items: [
                        ...acc.items,
                        ...selectedOptions.map(option => `${option.name} ${option.quantity > 1 ? `x ${option.quantity}` : ''}`),
                    ],
                }
            },
            { price: 0, items: [] }
        )
    }, [product.selections])

    const itemTotalPrice = useMemo(() => {
        return product.variants.reduce(
            (total, variant) => total + (variant.sellPrice + selectionsMap.price) * variant.quantity,
            0
        )
    }, [product.variants, selectionsMap.price])

    const totalQuantity = useMemo(() => {
        return product.variants.reduce((total, variant) => total + variant.quantity, 0)
    }, [product.variants])

    // const totalPrice = useMemo(() => {
    //     return product.variants.reduce(
    //         (total, variant) => total + (variant.sellPrice + selectionsMap.price) * variant.quantity,
    //         0
    //     )
    // }, [product.variants, selectionsMap])

    // const _renderServingTime = () => {
    //     return (
    //         <div className="serving-time-container">
    //             {/* <span className="serving-time-text">{moment(product.servingDate).format('YYYY-MM-DD')}</span> */}
    //         </div>
    //     )
    // }

    const confirmRemoveVariant = async (index, variantId) => {
        const variant = product.variants.find(v => v.id === variantId)
        if (variant && variant.quantity === 1) {
            const isConfirmed = await confirm('Are you sure you want to remove this item from cart?')
            if (isConfirmed) {
                if (product.variants.length === 1) {
                    removeItem(index)
                } else {
                    removeVariant(index, variantId)
                }
            }
        } else {
            minusQuantity(index, variantId)
        }
    }

    const handleRemoveItem = async () => {
        const isConfirmed = await confirm('Are you sure you want to remove this item from cart?')
        if (isConfirmed) {
            removeItem(index)
        }
    }

    const _renderProductImage = () => {
        return (
            <div className="cart-item-image-container-new">
                {product.dishId && !imageError ?
                    <img
                        src={getDishImageUrl(product.dishId)}
                        alt={product.name}
                        className="cart-item-image-new"
                        onError={() => setImageError(true)}
                    />
                :   <div className="cart-item-image-placeholder-new">
                        <i className="bx bx-image-alt" style={{ fontSize: '24px', color: '#ccc' }} />
                    </div>
                }
            </div>
        )
    }

    const _renderProductVariant = () => {
        if (!product?.variants?.length) return null

        return (
            <div className="product-details mt-2">
                <div className="variant-container">
                    {product.variants.map(variant => (
                        <div key={variant.id} className="variant-item mt-4 mb-0">
                            <p className="variant-name mb-2">
                                {variant.name && variant.name !== 'Default Title' ? variant.name : ''}
                            </p>
                            <div className="d-flex d-flex-row align-items-center justify-content-between">
                                <p className="variant-price">${(variant.sellPrice + selectionsMap.price).toFixed(2)}</p>

                                <div className="cart-item-quantity-control">
                                    <i
                                        className="bx bx-minus cart-item-quantity-icon"
                                        onClick={() => confirmRemoveVariant(index, variant.id)}
                                    ></i>
                                    <span className="cart-item-quantity-number">{variant.quantity}</span>
                                    <i
                                        className="bx bx-plus cart-item-quantity-icon"
                                        onClick={() => plusQuantity(index, variant.id)}
                                    ></i>
                                </div>
                            </div>
                            {GST_STALL_LIST.includes(product?.stallName) && (
                                <p className="text-secondary m-0" style={{ fontSize: '12px' }}>
                                    (Inclusive of GST)
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <>
            <Card className="cart-item-new">
                <CardBody className="p-3">
                    <div className="d-flex align-items-start">
                        {_renderProductImage()}
                        <div className="flex-grow-1">
                            <div className="d-flex justify-content-between align-items-start mb-2 gap-2">
                                <div className="flex-grow-1">
                                    <h6 className="cart-item-title-new mb-1">{product.name}</h6>
                                    <p className="cart-item-note-text mb-2">{product.stallName}</p>

                                    {selectionsMap.items.length > 0 && (
                                        <p className="cart-item-selection-text mb-2">{selectionsMap.items.join(', ')}</p>
                                    )}

                                    {/* product note */}
                                    {product.note && (
                                        <p className="cart-item-note-text mb-2" style={{ fontStyle: 'italic' }}>
                                            Note: {product.note}
                                        </p>
                                    )}
                                </div>
                                <i className="bx bx-trash cart-item-delete-icon" onClick={handleRemoveItem} />
                            </div>
                            {/* product variant */}
                            {_renderProductVariant()}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </>
    )
}

const CartList = () => {
    const { items } = useCartRedux()

    return (
        <div className="cart-list">
            {items.map((item, idx) => (
                <CartItem key={idx} product={item} index={idx} />
            ))}
        </div>
    )
}

export default CartList
